import { Component, inject } from '@angular/core';
import {
  RdsDialogModule,
  RdsButtonModule,
  RDS_DIALOG_DATA,
  RdsIconsModule,
} from '@rds/angular-components';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'inexp-confirm-dialog',
  imports: [
    RdsDialogModule,
    RdsButtonModule,
    RdsIconsModule,
    RouterModule,
    RdsIconsModule,
  ],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  protected readonly data = inject(RDS_DIALOG_DATA) as {
    title: string;
    message: string;
    warning?: string;
    icon: string;
    iconColor: string;
    confirmText?: string;
    cancelText?: string;
  };
}
